import labels from "app/labels";
import entityBase from "entityBase";
import * as _ from "lodash";

export class MeterReadingContractDetailMeterPlans extends entityBase {
  meter_plan_sequence: string;
  meter_plan_id: string;
  user_def2: string;
  meter_sing_or_pool: string;
  allowance_qty: number;
  price_per_print_included: number;
  amount_per_period: number;
  amount_per_period_string: string;
  price_per_extra_print: number;
  invoice_rule: string;
  invoice_rule_description: string;
  meter_invoice_rule: string;
  meter_invoice_rule_description: string;
  meter_financial_list_html_print_included: any;
  meter_financial_list_html_extra_print: any;

  start_with_letters: string;

  constructor(item, products, bill_period, contract) {
    super();
    this.meter_plan_sequence = item.meter_plan_sequence;
    this.meter_plan_id = item.meter_plan_id;

    this.start_with_letters = item?.meter_plan_id?.slice(0, 2);

    this.user_def2 = item.user_def2;
    if (item.allowance_plan == "Y" && item.multi_line_allowance == "N") this.meter_sing_or_pool = "Single";
    else this.meter_sing_or_pool = "Pool";
    this.allowance_qty = Number(item.allowance_qty);

    if (item.meter_financial_list) {
      const list = Array.isArray(item.meter_financial_list) ? item.meter_financial_list : [item.meter_financial_list];

      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      const foundItemInInterval = list.find((elem) => {
        const efective_dt = new Date(elem.effective_dt);
        const expiration_dt = new Date(elem.expiration_dt || tomorrow);
        return efective_dt <= today && expiration_dt >= today;
      });

      this.price_per_print_included = Number(foundItemInInterval?.user_def_num1);
      this.price_per_extra_print = Number(foundItemInInterval?.unit_price);

      this.amount_per_period = Number((item.allowance_qty * this.price_per_print_included).toFixed(4));

      //#region Popup print included
      let resultPrintIncluded = "";
      list.forEach((elem) => {
        let effective_dt_formatted = this.formatStringDate(elem.effective_dt);
        effective_dt_formatted = effective_dt_formatted !== "Invalid date" ? effective_dt_formatted : null;
        let expiration_dt_formatted = this.formatStringDate(elem.expiration_dt);
        expiration_dt_formatted = expiration_dt_formatted !== "Invalid date" ? expiration_dt_formatted : null;

        if (elem.metrix_row_num === foundItemInInterval?.metrix_row_num) {
          resultPrintIncluded += `<span style="font-weight:bold;display:flex;flex-direction:row;flex-wrap:no-wrap;">${effective_dt_formatted} - ${
            expiration_dt_formatted || labels.descr("cc_P_CURRENT")
          }: ${this.price_per_print_included.toFixed(6)}</span>`;
        } else {
          resultPrintIncluded += `<span style="display:flex;flex-direction:row;white-space: nowrap;">${effective_dt_formatted} - ${
            expiration_dt_formatted || labels.descr("cc_P_CURRENT")
          }: ${this.price_per_print_included.toFixed(6)}</span>`;
        }
      });
      const divForIncluded = document.createElement("div");
      divForIncluded.style.display = "flex";
      divForIncluded.style.flexDirection = "column";

      divForIncluded.innerHTML = resultPrintIncluded.trim();
      this.meter_financial_list_html_print_included = divForIncluded;
      //#endregion

      //#region Popup extra print
      let result = "";
      list.forEach((elem) => {
        let effective_dt_formatted = this.formatStringDate(elem.effective_dt);
        effective_dt_formatted = effective_dt_formatted !== "Invalid date" ? effective_dt_formatted : null;
        let expiration_dt_formatted = this.formatStringDate(elem.expiration_dt);
        expiration_dt_formatted = expiration_dt_formatted !== "Invalid date" ? expiration_dt_formatted : null;

        if (elem.metrix_row_num === foundItemInInterval?.metrix_row_num) {
          result += `<span style="font-weight:bold;display:flex;flex-direction:row;flex-wrap:no-wrap;">${effective_dt_formatted} - ${
            expiration_dt_formatted || labels.descr("cc_P_CURRENT")
          }: ${this.price_per_extra_print.toFixed(6)}</span>`;
        } else {
          result += `<span style="display:flex;flex-direction:row;white-space: nowrap;">${effective_dt_formatted} - ${
            expiration_dt_formatted || labels.descr("cc_P_CURRENT")
          }: ${this.price_per_extra_print.toFixed(6)}</span>`;
        }
      });
      const div = document.createElement("div");
      div.style.display = "flex";
      div.style.flexDirection = "column";

      div.innerHTML = result.trim();
      this.meter_financial_list_html_extra_print = div;
      //#endregion
    }

    if (products) {
      if (Array.isArray(products)) {
        let asocProduct = _.find(products, (o) => {
          if (Array.isArray(o["contr_product_meter_plan"])) {
            let found_cpmp = _.find(o["contr_product_meter_plan"], (cpmp) => {
              if (cpmp["meter_plan_sequence"] == item.meter_plan_sequence) return cpmp;
            });
            if (found_cpmp) return found_cpmp;
          } else {
            if (
              o["contr_product_meter_plan"] &&
              o["contr_product_meter_plan"]["meter_plan_sequence"] == item.meter_plan_sequence
            )
              return o;
          }
        });
        if (asocProduct) {
          this.invoice_rule = asocProduct.contr_inv_rule;
          this.meter_invoice_rule = asocProduct.meter_inv_rule;
        }
      } else {
        this.invoice_rule = products.contr_inv_rule;
        this.meter_invoice_rule = products.meter_inv_rule;
      }
      if (bill_period) {
        if (Array.isArray(bill_period)) {
          let found_inv_rule_desc = _.find(bill_period, (bp) => {
            if (Array.isArray(contract["contr_inv_rules"])) {
              let found_rule = _.find(contract["contr_inv_rules"], (cir) => {
                if (cir["contr_inv_rule"] == this.invoice_rule) return true;
              });
              if (found_rule && found_rule["bill_period_type"] == bp["bill_period_type"]) return true;
            } else {
              if (
                contract["contr_inv_rules"] &&
                contract["contr_inv_rules"]["contr_inv_rule"] == this.invoice_rule &&
                contract["contr_inv_rules"]["bill_period_type"] == bp["bill_period_type"]
              )
                return true;
            }
          });
          if (found_inv_rule_desc) {
            this.invoice_rule_description = found_inv_rule_desc["description"];
          }
          let found_meter_inv_rule_desc = _.find(bill_period, (bp) => {
            if (Array.isArray(contract["contr_inv_rules"])) {
              let found_rule = _.find(contract["contr_inv_rules"], (cir) => {
                if (cir["contr_inv_rule"] == this.meter_invoice_rule) return true;
              });
              if (found_rule && found_rule["bill_period_type"] == bp["bill_period_type"]) return true;
            } else {
              if (
                contract["contr_inv_rules"] &&
                contract["contr_inv_rules"]["contr_inv_rule"] == this.meter_invoice_rule &&
                contract["contr_inv_rules"]["bill_period_type"] == bp["bill_period_type"]
              )
                return true;
            }
          });
          if (found_meter_inv_rule_desc) {
            this.meter_invoice_rule_description = found_meter_inv_rule_desc["description"];
          }
        }
      } else {
        if (Array.isArray(contract["contr_inv_rules"])) {
          let found_rule = _.find(contract["contr_inv_rules"], (cir) => {
            if (cir["contr_inv_rule"] == this.invoice_rule) return cir["bill_period_type"];
          });
          if (found_rule && found_rule["bill_period_type"] == bill_period["bill_period_type"])
            this.invoice_rule_description = bill_period["description"];
        } else {
          if (
            contract["contr_inv_rules"] &&
            contract["contr_inv_rules"]["contr_inv_rule"] == this.invoice_rule &&
            contract["contr_inv_rules"]["bill_period_type"] == bill_period["bill_period_type"]
          )
            this.invoice_rule_description = bill_period["description"];
        }
        if (Array.isArray(contract["contr_inv_rules"])) {
          let found_rule = _.find(contract["contr_inv_rules"], (cir) => {
            if (cir["contr_inv_rule"] == this.meter_invoice_rule) return cir["bill_period_type"];
          });
          if (found_rule && found_rule["bill_period_type"] == bill_period["bill_period_type"])
            this.meter_invoice_rule_description = bill_period["description"];
        } else {
          if (
            contract["contr_inv_rules"] &&
            contract["contr_inv_rules"]["contr_inv_rule"] == this.meter_invoice_rule &&
            contract["contr_inv_rules"]["bill_period_type"] == bill_period["bill_period_type"]
          )
            this.meter_invoice_rule_description = bill_period["description"];
        }
      }
      if (typeof this.invoice_rule_description === "undefined" || this.invoice_rule_description == "") {
        this.invoice_rule_description = this.invoice_rule;
      }
      if (typeof this.meter_invoice_rule_description === "undefined" || this.meter_invoice_rule_description == "") {
        this.meter_invoice_rule_description = this.meter_invoice_rule;
      }
    }
    if (typeof this.amount_per_period !== "undefined" || this.amount_per_period != "") {
      this.amount_per_period_string =
        this.amount_per_period + (this.invoice_rule_description ? " / " + this.invoice_rule_description : "");
    }
  }
}
